import combiInterest, {
  CombiInterestStepContext,
} from '~/steps/combi/combi-interest';
import combiHousingSituation, {
  CombiHousingSituationStepContext,
} from '~/steps/combi/housing-situation';
import combiInitialSituation, {
  CombiInitialSituationStepContext,
} from '~/steps/combi/initial-situation';
import combiRoof, { CombiRoofStepContext } from '~/steps/combi/roof';
import combiHeating, { CombiHeatingStepContext } from './combi-heating';

// Add the imported StepDefinition from the steps in the order
// the steps should be shown in the assistant.
const steps = [
  combiInterest,
  combiHousingSituation,
  combiInitialSituation,
  combiRoof,
  combiHeating,
];

// Add the imported context interface for the steps
export interface CombiAssistantContext {
  combiInterest: CombiInterestStepContext;
  combiHousingSituation: CombiHousingSituationStepContext;
  combiInitialSituation: CombiInitialSituationStepContext;
  combiRoof: CombiRoofStepContext;
  combiHeating: CombiHeatingStepContext;
}

export default steps;
